import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'issue-field-atlas-project-common.inheritance-popup.title.non-final',
		defaultMessage: 'Inherited projects',
		description: 'Title of the inheritance popup, indicating that this atlas project is inherited',
	},
	description: {
		id: 'issue-field-atlas-project-common.inheritance-popup.description.non-final',
		defaultMessage:
			'This work item’s project comes from its parent work item. To change the project, select {workItemKey} below.',
		description:
			'Description of the inheritance popup, indicating that the atlas project comes from the parent work item',
	},
	moreInformation: {
		id: 'issue-field-atlas-project-common.inheritance-popup.more-information.non-final',
		defaultMessage: 'More on project inheritance',
		description: 'Link to more information about project inheritance',
	},
	errorLoadingInheritancePopupTitle: {
		id: 'issue-field-atlas-project-common.inheritance-popup.error-loading.title.non-final',
		defaultMessage: "We couldn't load the inheritance details",
		description: 'Error message title when inheritance popup fails to load',
	},
	errorLoadingInheritancePopupMessage: {
		id: 'issue-field-atlas-project-common.inheritance-popup.error-loading.message.non-final',
		defaultMessage: 'Check your connection, then try again.',
		description: 'Error message when inheritance popup fails to load',
	},
});
